'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = exports.PopoverContext = exports.defaultPopoverContext = undefined;

var _react = require('react');

var defaultPopoverContext = exports.defaultPopoverContext = {
  use: 'default'
};

var PopoverContext = exports.PopoverContext = (0, _react.createContext)(defaultPopoverContext);

var Consumer = PopoverContext.Consumer,
    Provider = PopoverContext.Provider;
exports.Consumer = Consumer;
exports.Provider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/context/PopoverContext.js
// module id = 78
// module chunks = 177